import { FC } from 'react';

import style from './FormResult.css';
import { UIText1 } from '@cian/ui-kit';
import cn from 'clsx';

import infoImg from '../assets/info.png';
import paperPlaneImg from '../assets/paper-plane.png';
import { TSuperhostSubmitError } from '../../../slices';

interface IFormResultProps {
  type: 'success' | 'error';
  errorCode?: TSuperhostSubmitError | null;
}

const getErrorContent = (
  errorCode: TSuperhostSubmitError | null | undefined,
): { title: React.ReactNode; description: React.ReactNode } => {
  switch (errorCode) {
    case 'hasRequestBefore':
      return {
        title: <>Не можем принять эту&nbsp;заявку</>,
        description:
          'Вы уже отправляли заявку ранее – в течение календарного года можно заказать наклейки только один раз',
      };
    case 'missingPublishedOffers':
      return {
        title: <>Не можем принять эту&nbsp;заявку</>,
        description:
          'У вас нет опубликованных объявлений в разделе посуточной аренды – опубликуйте из черновиков или разместите новые',
      };
    case 'notSuperHost':
      return {
        title: <>Не можем принять эту&nbsp;заявку</>,
        description: (
          <>
            Сначала получите статус Суперхозяин в личном кабинете&nbsp;– проверьте показатели качества сервиса и
            выполните задания
          </>
        ),
      };
    case 'unauthorized':
      return {
        title: <>Не можем принять эту&nbsp;заявку</>,
        description: <>Войдите в аккаунт, чтобы отправить заявку.</>,
      };
    default:
      return {
        title: 'Произошла ошибка',
        description: 'Попробуйте позже или обратитесь в поддержку.',
      };
  }
};

export const FormResult: FC<IFormResultProps> = ({ type, errorCode }) => {
  if (type === 'success') {
    return (
      <div className={style['container']}>
        <div className={style['content']}>
          <img src={paperPlaneImg} className={cn(style['image'], style['image_success'])} alt="" />
          <h2 className={style['title']}>Спасибо!</h2>
          <div className={style['success-text']}>
            <UIText1 textAlign="center">Получили вашу заявку</UIText1>
            <UIText1 textAlign="center">Ожидайте доставку в почтовый ящик по указанному в заявке адресу</UIText1>
          </div>
        </div>
      </div>
    );
  }

  const content = getErrorContent(errorCode);

  return (
    <div className={style['container']}>
      <div className={style['content']}>
        <img src={infoImg} className={style['image']} alt="" />
        <h2 className={cn(style['title'], style['title_error'])}>{content.title}</h2>
        <UIText1 textAlign="center">{content.description}</UIText1>
      </div>
    </div>
  );
};
